const themeContract = {
  tu: {
    heading: {
      display: 'display-3',
      color: 'brand-1'
    }
  },
  argos: {
    heading: {
      display: 'display-2',
      color: 'grey-90'
    }
  },
  habitat: {
    heading: {
      display: 'display-2',
      color: 'brand-1'
    }
  },
  nectar: {
    heading: {
      display: 'display-2',
      color: 'purple-90'
    }
  },
  sainsburys: {
    heading: {
      display: '',
      color: 'grey-80'
    }
  }
}

export { themeContract }
